Object.defineProperty(exports, "__esModule", { value: true });
exports.Ul = exports.Time = exports.Tr = exports.Th = exports.Td = exports.Table = exports.Strong = exports.Pre = exports.Ol = exports.Li = exports.Hr = exports.Dt = exports.Dl = exports.Dd = exports.Code = exports.Blockquote = exports.getSelf = void 0;
const core_1 = require("@emotion/core");
const styled_system_1 = require("@wheelroom/styled-system");
const merge_ncss_1 = require("../lib/merge-ncss");
const element_1 = require("./element");
const self_blockquote_reset_1 = require("./self-blockquote-reset");
const self_code_reset_1 = require("./self-code-reset");
const self_dl_reset_1 = require("./self-dl-reset");
const self_hr_reset_1 = require("./self-hr-reset");
const self_list_reset_1 = require("./self-list-reset");
const self_pre_reset_1 = require("./self-pre-reset");
const self_strong_reset_1 = require("./self-strong-reset");
const self_table_reset_1 = require("./self-table-reset");
const self_time_reset_1 = require("./self-time-reset");
exports.getSelf = (props, reset, elementName, extraAttrs = {}, htmlName = '') => {
    const label = { ncss: { label: elementName } };
    const ncss = merge_ncss_1.mergeNcss([
        label,
        reset,
        props.wheel.elementNcss[elementName],
        props.wheel.style,
        props,
    ]);
    const attrs = element_1.getElementAttrs(props, extraAttrs);
    attrs.css = styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, ncss);
    return core_1.jsx(htmlName || elementName, attrs, props.children);
};
exports.Blockquote = (props) => {
    return exports.getSelf(props, self_blockquote_reset_1.selfBlockquoteReset, 'blockquote');
};
exports.Code = (props) => {
    return exports.getSelf(props, self_code_reset_1.selfCodeReset, 'code');
};
exports.Dd = (props) => {
    return exports.getSelf(props, self_dl_reset_1.selfDdReset, 'dd');
};
exports.Dl = (props) => {
    return exports.getSelf(props, self_dl_reset_1.selfDlReset, 'dl');
};
exports.Dt = (props) => {
    return exports.getSelf(props, self_dl_reset_1.selfDtReset, 'dt');
};
exports.Hr = (props) => {
    return exports.getSelf(props, self_hr_reset_1.selfHrReset, 'hr');
};
exports.Li = (props) => {
    return exports.getSelf(props, self_list_reset_1.selfListReset, 'li');
};
exports.Ol = (props) => {
    return exports.getSelf(props, self_list_reset_1.selfListReset, 'ol');
};
exports.Pre = (props) => {
    return exports.getSelf(props, self_pre_reset_1.selfPreReset, 'pre');
};
exports.Strong = (props) => {
    return exports.getSelf(props, self_strong_reset_1.selfStrongReset, 'strong');
};
exports.Table = (props) => {
    return exports.getSelf(props, self_table_reset_1.selfTableReset, 'table');
};
exports.Td = (props) => {
    return exports.getSelf(props, self_table_reset_1.selfTdReset, 'td');
};
exports.Th = (props) => {
    return exports.getSelf(props, self_table_reset_1.selfThReset, 'th');
};
exports.Tr = (props) => {
    return exports.getSelf(props, self_table_reset_1.selfTrReset, 'tr');
};
exports.Time = (props) => {
    return exports.getSelf(props, self_time_reset_1.selfTimeReset, 'time');
};
exports.Ul = (props) => {
    return exports.getSelf(props, self_list_reset_1.selfListReset, 'ul');
};
//# sourceMappingURL=self.js.map